import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import infoList from "../../mixins/infoList";
import { getGameRateList } from '@/api/data';
import DataOptions from "../../components/timeList/dataOptions.vue";
import serverList from "../../components/serverList/serverOptions.vue";
import channelOptions from "../../components/serverList/channelOptions.vue";
import { getGameServerMap, getChannelMap } from "@/utils/dictionary";
export default {
  components: {
    DataOptions: DataOptions,
    serverList: serverList,
    channelOptions: channelOptions
  },
  name: "gameRate",
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getGameRateList,
      formData: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      serverMap: {},
      channelMap: {}
    };
  },
  created: function created() {
    this.init();
    this.queryEvent();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var channelList, k;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getGameServerMap();
            case 2:
              _this.serverMap = _context.sent;
              _context.next = 5;
              return getChannelMap();
            case 5:
              channelList = _context.sent;
              for (k in channelList) {
                _this.channelMap[String(k)] = channelList[k];
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    queryEvent: function queryEvent() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.searchInfo.sdate = _this2.formData[0];
              _this2.searchInfo.edate = _this2.formData[1];
              _context2.next = 4;
              return _this2.getTableData();
            case 4:
              if (!_this2.tableData || _this2.tableData && _this2.tableData.length === 0) {
                _this2.$message({
                  message: "暂无数据"
                });
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};